import { Segment } from '@fixter/i18n';
import type { CmsPageCollectionItems, CmsAreaItem } from '$cms/types';

interface LinkObject {
  readonly name: string;
  readonly link: string;
}

export function makePopularAreaLink(
  pageCollectionItems: CmsPageCollectionItems,
  collectionItem: Pick<CmsAreaItem, 'name' | 'slug'>,
  segment?: Segment
): LinkObject {
  const { product } = pageCollectionItems;

  const frSegment = segment === Segment.Fixter_FR;

  let name = frSegment ? `Garages à ${collectionItem.name}` : `Garages in ${collectionItem.name}`;
  let link = frSegment ? `/${collectionItem.slug}` : `/mechanic-garage/${collectionItem.slug}`;

  if (product) {
    name = frSegment
      ? `${product.name} à ${collectionItem.name}`
      : `${product.name} in ${collectionItem.name}`;
    link = `/${product.slug}/${collectionItem.slug}`;
  }

  return {
    name: `${name}`,
    link,
  };
}
